module.exports = __webpack_public_path__ + "static/head-8950cb42e873190af94e4667741554b5.png";